export enum AwaitingReleaseResonEnum {
	QuoteChangeStatusDamagePayment = 1,
	QuoteChangeStatusTotalLoss = 2,
	QuoteChangeStatusNotDeductible = 3,
	QuoteChangeStatusPossibleTotalLoss = 4,
	QuoteChangeStatusNoSupplierAvaible = 5,
	QuoteChangeStatusNotAprroved = 6,
	EditPriceWrongPrice = 7,
	EditPriceOther = 8,
}
